module.exports = __webpack_public_path__ + "images/video_preview_stub.d5586f9d5034193df8cf0890579f48d2.png";